enum PageKey {
  Jobs = 'jobs',
  Breakdown = 'breakdown',
  FollowUp = 'followUp',
  Role = 'role',
  SelfTapeUpload = 'selfTapeUpload',
  SelfTapeRequest = 'selfTapeRequest',
  SelfTapeRequestNotifications = 'selfTapeRequestNotifications',
  AgentQuickSearch = 'agentQuickSearch',
}

export default PageKey;
